/**
 * Name of the cookie `SidebarProvider` writes on every toggle. Exported so the
 * apps that read it back are not each repeating the literal — the component
 * keeps its own private copy, and a drift between the two would silently stop
 * persistence working.
 */
export const SIDEBAR_COOKIE_NAME = "sidebar_state";

/**
 * Resolves the persisted sidebar state that `SidebarProvider` needs as its
 * `defaultOpen`.
 *
 * `SidebarProvider` writes `sidebar_state` on every toggle but never reads it
 * back — it seeds its state once from `defaultOpen` and nothing else. That is
 * stock shadcn behaviour: the consuming app is expected to read the cookie
 * server-side and feed it in. An app that mounts a bare `<SidebarProvider>`
 * therefore falls through to the hardcoded `true`, so a collapsed sidebar
 * springs open on any navigation that remounts the tree (GH #1194).
 *
 * The shared `AppSidebar` navigates with plain anchors rather than `next/link`,
 * so every top-level tab click is a full document load — which is exactly such
 * a remount.
 *
 * Pass `cookieStore.get(SIDEBAR_COOKIE_NAME)?.value`.
 */
export function resolveSidebarOpen(
  cookieValue: string | undefined | null
): boolean {
  // Only an explicit "false" collapses. An absent cookie means the user has
  // never toggled, and open is the correct first-run state; any other value is
  // treated as absent rather than guessed at.
  return cookieValue !== "false";
}
